import lodash from 'lodash';
import styles from './SystemProperties.scss';
import DateTime from 'common/components/DateTime/DateTime';
import { DEFAULT_DATETIME_INPUT_FORMAT } from 'common/util/dateTime';

const documentStatusLabelMap = {
    unindexed: 'Not Yet Indexed',
    indexed: 'Indexed'
};

export const SystemProperties = props => {
    const {document} = props;
    const uploadUser = document.uploadUser || {
        displayName: null,
        emailAddress: null
    };
    const commitUser = document.commitUser || {
        displayName: null,
        emailAddress: null
    };

    const documentStatus = documentStatusLabelMap[document.documentStatus];
    const systemProperties = {
        uploadUser: {
            visible: true,
            label: 'Uploaded By',
            value: <span className={styles.attributeValue}>{uploadUser.displayName}</span>,
            title: uploadUser.emailAddress
        },
        uploadDate: {
            visible: true,
            label: 'Uploaded Date/Time',
            value: <DateTime className={styles.attributeValue} inputFormat={DEFAULT_DATETIME_INPUT_FORMAT} value={document.uploadDate} time={true} />,
            title: document.uploadDate
        },
        commitUser: {
            visible: true,
            label: 'Initially Filed By',
            value: <span className={styles.attributeValue}>{commitUser.displayName}</span>,
            title: commitUser.emailAddress
        },
        commitDate: {
            visible: true,
            label: 'Initially Filed Date/Time',
            value: <DateTime className={styles.attributeValue} inputFormat={DEFAULT_DATETIME_INPUT_FORMAT} value={document.commitDate} time={true} />,
            title: document.commitDate
        },
        documentStatus: {
            visible: props.canViewDocumentStatus,
            label: 'Document Status',
            value: <span className={styles.attributeValue}>{documentStatus}</span>,
            title: documentStatus
        }
    };

    if (lodash.every(systemProperties, data => lodash.isEmpty(data.value))) {
        return null;
    }

    const renderedSystemProperties = lodash.map(systemProperties, (data, key) => {
        if (lodash.isEmpty(data.value)) {
            return null;
        }
        if (!data.visible) {
            return null;
        }

        return (
            <div key={key} title={data.title} className={styles.systemProperty} data-cy="SystemProperties">
                <span className={styles.attributeName}>{data.label}</span>
                {data.value}
            </div>
        );
    });

    return (
        <section className={styles.systemPropertiesArea} data-cy="SystemProperties-section">
            <header className={styles.header}>
                System Properties
            </header>
            <div className={styles.systemProperties} data-cy="SystemProperties-renderedSystemProperties">
                {renderedSystemProperties}
            </div>
        </section>
    );
};

export default SystemProperties;
